import { NavLink } from 'react-router-dom';

function Filter() {
    return (
       <>
         <div className="col-lg-3 col-md-4 col-sm-7 col-xs-12 pull-left">
                <div className="service-single-sidebar">
                    {/* <!--Start single sidebar--> */}
                    <div className="single-sidebar">
                        <ul className="service-lists">
                            {/* <li className="allservice"><a href="services.html">View All Services<i className="fa fa-cog" aria-hidden="true"></i></a></li> */}
                            <li><NavLink to="/market-food" className={({ isActive }) => (isActive ? 'active' : undefined)}>Food</NavLink></li>
                            <li><NavLink to="/market-dairy" className={({ isActive }) => (isActive ? 'active' : undefined)}>Dairy</NavLink></li>
                            <li><NavLink to="/market-HVAC" className={({ isActive }) => (isActive ? 'active' : undefined)}>Industrial HVAC</NavLink></li>
                            <li><NavLink to="/market-beverage" className={({ isActive }) => (isActive ? 'active' : undefined)}>Beverage</NavLink></li>
                            <li><NavLink to="/market-pharma" className={({ isActive }) => (isActive ? 'active' : undefined)}>Pharma</NavLink></li>
                            <li><NavLink to="/market-oil-gas-chemical" className={({ isActive }) => (isActive ? 'active' : undefined)}>Oil / Gas / Chemical / Power</NavLink></li>
                            <li><NavLink to="/market-Cold-Storage-and-WareHouse" className={({ isActive }) => (isActive ? 'active' : undefined)}>Cold Storage & WareHouse</NavLink></li>
                                  {/* <li><NavLink to="/market-General-Industries" className={({ isActive }) => (isActive ? 'active' : undefined)}>General Industries</NavLink></li> */}
                            {/* <li><NavLink to="/market-Public-Sector-Units" className={({ isActive }) => (isActive ? 'active' : undefined)}>Public Sector Units</NavLink></li> */}
                        </ul>
                    </div>
                    {/* <!--End single sidebar--> */}
                 
                </div>
            </div>

                    {/* <!--Scroll to top--> */}
                    {/* <div className="scroll-to-top scroll-to-target" data-target="html"><span className="fa fa-angle-up"></span></div> */}

       </>
    )
}

export default Filter;